import React, { useState } from "react";
import { Form, Input, Button, Image, message } from "antd";
import axios from "axios";
import JSZip from "jszip";
import { saveAs } from "file-saver";

const categories = {
    "Website Header": ["client/ennovation/728x90px", "client/ennovation/970x90px", "client/ennovation/970x250px"],
    "Klassische Banner": ["client/ennovation/160x600px", "client/ennovation/300x250px", "client/ennovation/300x600px"],
    "E-Mail-Signatur": ["client/ennovation/280x93px", "client/ennovation/468x60px"],
};

const Marketing = () => {
    const [form] = Form.useForm();
    const [images, setImages] = useState({});
    const [loading, setLoading] = useState(false);
    const [downloading, setDownloading] = useState(false);

    const apiUrl = "https://dash.ennovation-austria.com/api/v1/image/generate-synchronous";
    const token = "$2y$12$RZI/3VHY8vo824B0hXH0QO/YAdhN0bt0WFiUSY76pl6bfh5soG8dK";

    const handleSubmit = async (values) => {
        setLoading(true);
        try {
            const response = await axios.post(apiUrl, {
                id: "20d98707-f3b7-430c-8204-675072193708",
                ...values,
            }, {
                headers: { "x-api-key": token },
            });

            if (response.data && response.data.data) {
                setImages(response.data.data);
            }
        } catch (error) {
            console.error("Error generating images:", error);
        } finally {
            setLoading(false);
        }
    };

    const downloadImage = async (url) => {
        try {
            const response = await axios.get(url, { responseType: "blob" });
            const fileName = url.split("/").pop();
            saveAs(response.data, fileName);
        } catch (error) {
            console.error("Error downloading image:", error);
        }
    };

    const downloadAllImages = async () => {
        setDownloading(true);
        const zip = new JSZip();
        const folder = zip.folder("images");

        for (const key in images) {
            const url = images[key].url;
            try {
                const response = await axios.get(url, { responseType: "blob" });
                const fileName = url.split("/").pop();
                folder.file(fileName, response.data);
            } catch (error) {
                console.error("Error downloading image:", error);
            }
        }

        zip.generateAsync({ type: "blob" }).then((content) => {
            saveAs(content, "images.zip");
        }).catch(err => {
            message.error("Error in downloading images");
        }).finally(() => {
            setDownloading(false);
        });
    };

    return (
        <div style={{ position: "relative", color: "#fff", minHeight: "100vh" }}>
            <img style={{
                width: '100%',
                objectFit: 'contain',
                position: 'fixed',
                zIndex: -1
            }} src="https://cdn.prod.website-files.com/65f03c978efea1c906592c94/65f41d5f2ba41fbbe6c5514c_AdobeStock_546815906_gruen_klein_bearbeitet_002.webp" />
            <div
                style={{
                    padding: "40px",
                    maxWidth: "1020px",
                    margin: "20px auto",
                    borderRadius: "20px",
                    backgroundColor: "rgb(28, 28, 28, 0.95)",
                }}
            >
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center'
                }}>
                    <h2 style={{ color: "#0BD349", textAlign: "center" }}>Werbebanner-Generator</h2>
                    <p style={{
                        color: 'gray',
                        width: '80%',
                    }}>
                        Geben Sie Ihre Standnummer ein und erstellen Sie damit personalisierte digitale Werbebanner mit Ihrer Standnummer auf der ennovation Austria.
                    </p>
                </div>
                <Form form={form} layout="vertical" onFinish={handleSubmit}>
                    <Form.Item
                        label={<span style={{ color: "#ddd" }}>Stand Nummer</span>}
                        name="stand_no"
                        rules={[
                            { required: true, message: "Please input the stand number!" },
                            {
                                pattern: /^[1-9][0-9]{0,3}$/,
                                message: "Bitte geben Sie eine positive Zahl mit maximal 4 Ziffern ein",
                            },
                        ]}
                    >
                        <Input
                            placeholder="Geben Sie eine Standnummer ein"
                            style={{ backgroundColor: "#333", color: "#fff", border: "1px solid #444" }}
                            maxLength={4}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" loading={loading} style={{
                            backgroundColor: "#0BD349",
                            color: "#000",
                            border: "none"
                        }}>
                            Banner generieren
                        </Button>
                        {
                            Object.keys(images).length > 0 && (
                                <Button
                                    loading={downloading}
                                    type="primary"
                                    onClick={downloadAllImages}
                                    style={{
                                        marginLeft: '20px',
                                        backgroundColor: "#0BD349",
                                        border: "none",
                                        color: "#121212",
                                    }}
                                >
                                    Alle herunterladen
                                </Button>
                            )
                        }
                    </Form.Item>
                </Form>

                {Object.keys(images).length > 0 && Object.entries(categories).map(([category, paths], index) => (
                    <div key={category} style={{ marginBottom: 20 }}>
                        <details style={{ cursor: "pointer", color: "#0BD349" }} {...(index === 0 ? { open: true } : {})}>
                            <summary style={{ fontSize: "18px", color: "#0BD349", outline: "none" }}>
                                {category}
                            </summary>
                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
                                    gap: "20px",
                                    marginTop: "10px",
                                }}
                            >
                                {paths.map((path) => {
                                    const image = images[path];
                                    return image ? (
                                        <div
                                            key={path}
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <span style={{
                                                marginBottom: '10px'
                                            }}>{path.split('/')[2]}</span>
                                            <Image
                                                src={image.url}
                                                width={200}
                                                style={{
                                                    cursor: "pointer",
                                                    border: "1px solid #444",
                                                    borderRadius: "5px",
                                                }}
                                            />
                                            <Button
                                                type="link"
                                                onClick={() => downloadImage(image.url)}
                                                style={{ color: "#0BD349", marginTop: "5px" }}
                                            >
                                                Download
                                            </Button>
                                        </div>
                                    ) : null;
                                })}
                            </div>
                        </details>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Marketing;